export default __webpack_public_path__ + "static/media/next.33c783af.svg";